var BaseView = require('../components/accordion-list/content');
var AnalyticsDecorate = require('../../../analytics/decorate');

module.exports = AnalyticsDecorate(require('./analytics/stickers'), BaseView.extend({
  apiCall: 'search/stickers',
  dataName: 'stickerCategories',
  callbackName: 'callbackStickers',
  where: {},

  initialize: function (options) {
    this.category = options.key === 'all' ? 'all' : _.find(
      INKIVE.Tool._cache['stickerCategories'],
      function (category) {
        return parseInt(category.id) === options.key;
      }
    );

    BaseView.prototype.initialize.call(this, options);
  },

  getScrollHeight: function ($target) {
    var $tabContainer = $target.closest('.tab-content');
    var stockContentH = 0;

    var tabsH = $tabContainer.find('.header-links').outerHeight(true);
    var searchH = $tabContainer.find('.search-container').outerHeight(true);
    var siblings = Array.from(this.$el.siblings());
    siblings.forEach(sibling => stockContentH += $(sibling).outerHeight(true));

    return $tabContainer.height() - tabsH - searchH - stockContentH - parseInt($target.css('margin-top'));
  },

  getParams: function () {
    var params = {
      from: this.from,
      limit: this.limit,
      where: {
        category: this.category === 'all' ? null : this.category.name,
        active: INKIVE.C.USER.IS_SUPER ? 0 : 1
      }
    };

    this.from += this.limit;

    return params;
  },

  extractData: function (data) {
    this.searchInput.removeClass('disabled');

    return _.map(data, function (item) {
      return {
        id: 'icon-sticker-' + item['id'],
        src: item['url'],
        width: item['width'],
        height: item['height'],
        cls: parseInt(item['active']) ? '' : ' grayscale',
        data: {
          icon: true,
          name: item['name'],
          count: item['count'],
          changeable: item['changeable'],
          width: item['width'],
          height: item['height']
        }
      };
    });
  },

  render: function () {
    this.searchInput = this.$el.parents('.inner-tabs').find('input[name=search]').addClass('disabled');
    BaseView.prototype.render.call(this);
  }
}));
